import { eventsApiSlice } from '../../../../../store/eventApiSlice';

export const extendedApiSlice = eventsApiSlice
  .enhanceEndpoints({
    addTagTypes: ['EventType', 'AllEvent', 'VolunteerDeployment'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getEventTypes: builder.query({
        query: () => ({
          url: `event-admin/event-types`,
        }),
        providesTags: (result, error) => (error ? [] : [{ type: 'EventType' }]),
      }),
      getValidOrganiser: builder.query({
        query: ({ typeId, subTypeId = undefined }) => ({
          url: `event-admin/valid-organisers`,
          params: { event_type_id: typeId },
          useDefaultErrorHandler: false,
        }),
        providesTags: (result, error) =>
          error ? [] : [{ type: 'EventOrganiser' }],
      }),
      getAllEvent: builder.query({
        query: () => ({
          url: `event-admin/events/overview`,
        }),
        providesTags: (result, error) => (error ? [] : [{ type: 'AllEvent' }]),
      }),
      getEventDetails: builder.query({
        query: ({ Id }) => ({
          url: `event-admin/event/${Id}`,
        }),
        providesTags: (result, error) =>
          error ? [] : [{ type: 'EventDetails' }],
      }),
      deleteEvent: builder.mutation({
        query: (data) => ({
          url: `event-admin/event/${data?.id}`,
          method: 'delete',
        }),
        invalidatesTags: (result, error) => [
          { type: 'EventDetails' },
          { type: 'AllEvent' },
        ],
      }),
      sendEventCreateRequest: builder.mutation({
        query: (data) => ({
          url: `event-admin/event`,
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [
          { type: 'EventDetails' },
          { type: 'AllEvent' },
        ],
      }),
      sendEventUpdateRequest: builder.mutation({
        query: (data) => ({
          url: `event-admin/event/${data?.id}`,
          method: 'put',
          data,
        }),
        invalidatesTags: (result, error) => [
          { type: 'EventDetails' },
          { type: 'AllEvent' },
        ],
      }),
      getVolunteersDeployed: builder.query({
        query: ({ event_id }) => ({
          url: `event-admin/event/${event_id}/volunteer-deployment`,
        }),
        providesTags: (result, error) =>
          error ? [] : [{ type: 'VolunteerDeployment' }],
      }),
      deployVolunteer: builder.mutation({
        query: ({ event_id, organiser_id, register_access = false }) => ({
          url: `event-admin/event/${event_id}/volunteer-deployment/${organiser_id}`,
          method: 'post',
          params: { register_access: register_access },
        }),
        invalidatesTags: (result, error) => [{ type: 'VolunteerDeployment' }],
      }),
      deleteVolunteerDeployment: builder.mutation({
        query: ({ event_id, organiser_id }) => ({
          url: `event-admin/event/${event_id}/volunteer-deployment/${organiser_id}`,
          method: 'delete',
        }),
        invalidatesTags: (result, error) => [{ type: 'VolunteerDeployment' }],
      }),
      checkInVolunteer: builder.mutation({
        query: ({ event_id, organiser_id, checked_in }) => ({
          url: `event-admin/event/${event_id}/volunteer-check-in/${organiser_id}`,
          method: 'post',
          params: { value: checked_in },
        }),
        invalidatesTags: (result, error) => [{ type: 'VolunteerDeployment' }],
      }),
      duplicateEvent: builder.mutation({
        query: ({ event_id, payload }) => ({
          url: `event-admin/event/${event_id}/duplicate`,
          method: 'post',
          data: payload,
        }),
        invalidatesTags: (result, error) => [
          { type: 'EventDetails' },
          { type: 'AllEvent' },
        ],
      }),
      grantVolunteerAccess: builder.mutation({
        query: ({ event_id, organiser_id, register_access }) => ({
          url: `event-admin/event/${event_id}/volunteer-register-access/${organiser_id}`,
          method: 'post',
          params: { value: register_access },
        }),
        invalidatesTags: (result, error) => [{ type: 'VolunteerDeployment' }],
      }),
    }),
  });

export const {
  useGetEventTypesQuery,
  useGetAllEventQuery,
  useDeleteEventMutation,
  useGetEventDetailsQuery,
  useSendEventUpdateRequestMutation,
  useSendEventCreateRequestMutation,
  useGetValidOrganiserQuery,
  useGetVolunteersDeployedQuery,
  useDeployVolunteerMutation,
  useDeleteVolunteerDeploymentMutation,
  useCheckInVolunteerMutation,
  useDuplicateEventMutation,
  useGrantVolunteerAccessMutation,
} = extendedApiSlice;
